import { useState } from "react";

export function ForcePinResetButton({ child, data, onDataChange }) {
  const [done, setDone] = useState(false);
  function handleClick() {
    const updated = { ...data, users: data.users.map(u => u.id === child.id ? { ...u, mustResetPin: true, pin: "1234" } : u) };
    onDataChange(updated);
    setDone(true);
    setTimeout(() => setDone(false), 4000);
  }
  return done
    ? <span style={{ fontSize: ".82rem", fontWeight: 700, color: "var(--green)", alignSelf: "center" }}>✅ PIN reset — {child.name} must set a new PIN on next login</span>
    : <button className="wm-btn secondary" style={{ color: "var(--amber)", borderColor: "var(--amber)" }} onClick={handleClick}>🔐 Force PIN Reset</button>;
}
